import { useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import { useDispatch, useSelector } from "react-redux";
import { closemsg } from '../modules/msgboxstore';
import { isEmpty } from '../modules/appLibrary';
import imgcaut from '../Resources/caut.png';
import imginfo from '../Resources/info.png';
import imgconf from '../Resources/conf.png';

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

export default function MsgBox() {
    const dispatch = useDispatch();
    const open = useSelector(state => state.msgbox.open);
    const message = useSelector(state => state.msgbox.message);
    const type = useSelector(state => state.msgbox.type);
    const docmd = useSelector(state => state.msgbox.doCommand);
    const docmd2 = useSelector(state => state.msgbox.doCommand2);
    const docancel = useSelector(state => state.msgbox.doCancel);
    const label1 = useSelector(state => state.msgbox.btnlabel1);
    const label2 = useSelector(state => state.msgbox.btnlabel2);
    const [msg, setmsg] = useState(message);

    useEffect(() => {
        if (Array.isArray(message)) {
            setmsg(message.map((e) => <div>{e}</div>));
        } else {
            let newmsg = message.split(/\r\n|\n/);
            if (newmsg.length > 1) {
                setmsg(newmsg.map((e) => <div>{e}</div>));
            } else {
                setmsg(message);
            }
        }
    }, [message]);

     function handleClose(){
        dispatch(closemsg());
    };
    function OKClick() {
        handleClose();
        if (type !== 0 && !isEmpty(docmd))
            docmd();
    }
    function CancelClick() {
        handleClose();
        if (!isEmpty(docancel)) {
            docancel();
        }
    }
    function onClick() {
        handleClose();
        docmd2();
    }
    function SecondBotton(){
        if (type === 1) {
            return (
                <Button autoFocus onClick={CancelClick} variant="outlined" color="primary">
                    Cancel
                </Button>
            );
        } else if (type === 2){
            return (
                <Button autoFocus onClick={onClick} variant="outlined" color="primary">
                    {label2 === "" ? "No" : label2}
                </Button>
            );
        } else {
            return null;
        }
    }
    function ThirdBotton() {
        if (type === 2) {
            return (
                <Button autoFocus onClick={CancelClick} variant="outlined" color="primary">
                    Cancel
                </Button>
            );
        } else {
            return null;
        }
    }

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                disableBackdropClick={true}
                fullWidth={true}
                maxWidth={"sm"}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                aria-describedby="common-dialog-description"
            >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title"/>
                <DialogContent>
                    <div style={{ position: 'absolute', top: 30, left: 20 }}>
                        <img src={type === 0 ? imgcaut : (type===3?imginfo:imgconf)} style={{ height:30 }} alt="" />
                    </div>
                    <div style={{ marginLeft: 50, marginBottom:20 }}>{msg}</div>
                {/*    <DialogContentText>{msg}</DialogContentText>*/}
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={OKClick} variant="outlined" color="primary">
                        {label1 !== "" ? label1 : (type<=1||type===3?"OK":"Yes")}
                    </Button>
                    <SecondBotton/>
                    <ThirdBotton />
                </DialogActions>
            </Dialog>
        </div>
    );
}